const DEFAULT_DOCUMENT_TITLE = "Metroscope";

type DocumentTitle = () => string;
type ProjectDocumentTitle = (projectName: string) => string;

type ResolveDocumentTitleParameters = {
  documentTitle?: DocumentTitle;
  projectDocumentTitle?: ProjectDocumentTitle;
  projectName?: string;
  preserveDuringNavigation?: boolean;
};

export type TitleHandle = {
  documentTitle?: DocumentTitle;
  projectDocumentTitle?: ProjectDocumentTitle;
};

export function isProjectHomePath(pathname: string): boolean {
  return /^\/projects\/[^/]+\/summary(?:\/|$)/.test(pathname);
}

export function resolveDocumentTitle({
  documentTitle,
  projectDocumentTitle,
  projectName,
  preserveDuringNavigation = false,
}: ResolveDocumentTitleParameters): string | null {
  if (documentTitle) return documentTitle();
  if (projectDocumentTitle) {
    if (!projectName) return null;
    return projectDocumentTitle(projectName);
  }
  if (preserveDuringNavigation) return null;

  return DEFAULT_DOCUMENT_TITLE;
}

export { DEFAULT_DOCUMENT_TITLE };
